import React, { useState } from 'react';
import axios from 'axios';
import Footer from './sections/Footer.js';
import LogoMenu from './sections/Menu.js';
import phone_img from './assets/here4u_phone_splash.png';
import arrowBlackRight from './assets/arrow redirect black.png';
import './ContactUs.css';
import config from "./config.js";


async function PostContactRequest(data) {
  try {
    await axios.post(config.messagesApi.URL + config.messagesApi.PATH, {
      htmlBody: `<html><head></head><body><h3>here4u.care</h3><p>Email: ${data.email}</p><p>Name: ${data.name}</p>Telephone: ${data.telephone}<p>Message: ${data.message}</p></body></html>`,
      subject: "Here4U Contact Us Outreach",
      source: config.sourceEmail,
      filename: "",
      tenant: "",
      persist: "enable",
      attachment: "",
      destination: config.destinationEmail
    }, {
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY_VALUE,
        'Content-Type': 'application/json'
      }
    });
  } catch (e) {
    console.error("**** e: ", e);
  }
}

function ValidatedInput({ type, name, placeholder, required, value, onChange, isValid }) {
    return (
        type === "textarea" 
        ?
        <div className="input-icon-container">
            <textarea 
                name={name}
                placeholder={placeholder}
                rows="4" 
                required 
                value={value}
                onChange={onChange}
            />
            <span className="input-icon">
            {
                isValid
                    ? <i className="fa-solid fa-circle-check"></i>
                    : <i className="fa-solid fa-circle-xmark" style={{ color: 'red' }}></i>
            }
            </span>
        </div>
        :
        <div className="input-icon-container">
            <input
                type={type}
                name={name}
                placeholder={placeholder}
                required={required}
                value={value}
                onChange={onChange}
            />
            <span className="input-icon">
                {
                    isValid
                        ? <i className="fa-solid fa-circle-check"></i>
                        : <i className="fa-solid fa-circle-xmark" style={{ color: 'red' }}></i>
                }
            </span>
        </div>
    );
}

function ContactUs() {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        message: ''
    });
    const [formErrors, setFormErrors] = useState({
        firstName: true,
        lastName: true,
        email: true,
        telephone: true,
        message: true  
    })

    const validateName = (name) => /^[A-Za-z]{1,25}$/.test(name);
    const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    const validateTelephone = (telephone) => /^\d{10}$/.test(telephone);
    const validateMessage = (message) => message.length >= 1;

    const validateField = (name, value) => {
        switch (name) {
            case "firstName":
            case "lastName":
                return validateName(value);
            case "email":
                return validateEmail(value);
            case "telephone":
                return value === '' || validateTelephone(value);
            case "message":
                return validateMessage(value);
            default:
                return true;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        const error = validateField(name, value);
        setFormErrors(prevState => ({
            ...prevState,
            [name]: !error
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        //Prepare fields before passing to API call. 
        const data = {
            email: formData.email,
            name: formData.firstName + ' ' + formData.lastName,
            telephone: formData.telephone,
            message: formData.message
        };

        PostContactRequest(data);

        //Clear form and error data after submitting
        setFormErrors({
            firstName: true,
            lastName: true,
            email: true,
            telephone: true,
            message: true              
        });
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            telephone: '',
            message: ''
        });
    };

    const isFormValid = Object.entries(formErrors)
        .filter(([key]) => key !== 'telephone')
        .every(([_, error]) => error === false) &&
        formData.firstName &&
        formData.lastName &&
        formData.email &&
        formData.message;

    return (
        <div className="ContactUs-page">
            {/* <div style={{padding: '1rem'}}> */}
                <LogoMenu />
            {/* </div> */}
            <div className="ContactUs-section">
                <h2>
                    JOIN THE CAUSE
                </h2>
                <h1>
                    Become a partner
                </h1>
                <p>
                    We welcome professionals and organizations to join a growing network 
                    committed to expanding access to mental health support. Whether you 
                    provide clinical services, coaching, crisis response, educational 
                    resources, or self-guided tools, there’s a place for your offerings 
                    within the Here4U platform. 

                    <br/><br/>
                    United by a shared mission to address the full spectrum of mental 
                    health needs - from early intervention to long-term care - we help 
                    integrate and amplify partner services to connect with those actively 
                    seeking support. Partnership begins with a simple conversation, and 
                    we are ready to explore how we can work together to create lasting 
                    impact. 
                </p>
                <img src={phone_img} className="ContactUs-overlay-image" alt="Here4U Splash Screen" />
            </div>
            <div className="ContactUs-section">
                <h2>
                    CONTACT US
                </h2>
                <h1>
                    Let's explore possibilities
                </h1>
                <div className="ContactUs-form">
                    <form className="ContactUs-form-fields" onSubmit={handleSubmit}>                      
                        <ValidatedInput
                            type="text"
                            name="firstName"
                            placeholder="First name"
                            required
                            value={formData.firstName}
                            onChange={handleChange}
                            isValid={!formErrors.firstName}
                        />
                        <ValidatedInput
                            type="text"
                            name="lastName"
                            placeholder="Last name"
                            required
                            value={formData.lastName}
                            onChange={handleChange}
                            isValid={!formErrors.lastName}
                        />
                        <ValidatedInput
                            type="email"
                            name="email"
                            placeholder="Email address"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            isValid={!formErrors.email}
                        />
                        <ValidatedInput 
                            type="tel"
                            name="telephone"
                            placeholder="Telephone (optional)"
                            value={formData.telephone}
                            onChange={handleChange}
                            isValid={!formErrors.telephone}
                        />
                        <ValidatedInput 
                            type="textarea"
                            name="message"
                            placeholder="Short message"
                            value={formData.message}
                            onChange={handleChange}
                            isValid={!formErrors.message}
                        />
                        <button
                          type="submit"
                          className="ContactUs-submit-button"
                          disabled={!isFormValid}
                          style={{ background: 'none', border: 'none', padding: 0, cursor: isFormValid ? 'pointer' : 'not-allowed' }}
                        >
                          <img src={arrowBlackRight} alt="Submit" style={{ opacity: isFormValid ? 1 : 0.4 }} />
                        </button>                        
                    </form>                 
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ContactUs;
